import { useEffect, useRef } from "react";
import { CaretLeft, CaretRight, X } from "@phosphor-icons/react";

export const Lightbox = ({ src, alt, caption, onClose, onPrev, onNext }) => {
    const touchX = useRef(null);
    useEffect(() => {
        const onKey = (e) => {
            if (e.key === "Escape") onClose();
            if (e.key === "ArrowLeft" && onPrev) onPrev();
            if (e.key === "ArrowRight" && onNext) onNext();
        };
        window.addEventListener("keydown", onKey);
        document.body.style.overflow = "hidden";
        return () => {
            window.removeEventListener("keydown", onKey);
            document.body.style.overflow = "";
        };
    }, [onClose, onPrev, onNext]);

    const onTouchStart = (e) => {
        touchX.current = e.touches[0].clientX;
    };
    const onTouchEnd = (e) => {
        if (touchX.current == null) return;
        const dx = e.changedTouches[0].clientX - touchX.current;
        if (dx > 50 && onPrev) onPrev();
        else if (dx < -50 && onNext) onNext();
        touchX.current = null;
    };

    return (
        <div
            className="fixed inset-0 z-50 bg-black/90 flex items-center justify-center"
            onClick={onClose}
            onTouchStart={onTouchStart}
            onTouchEnd={onTouchEnd}
            data-testid="lightbox-overlay"
        >
            <button
                data-testid="lightbox-close"
                onClick={onClose}
                className="absolute top-4 right-4 z-10 text-white/90 hover:text-white bg-white/10 rounded-full p-2.5 transition-colors"
                title="Tutup"
            >
                <X size={24} weight="bold" />
            </button>
            {onPrev && (
                <button
                    data-testid="lightbox-prev"
                    onClick={(e) => {
                        e.stopPropagation();
                        onPrev();
                    }}
                    className="absolute left-2 sm:left-4 z-10 text-white/90 hover:text-white bg-white/10 rounded-full p-2.5 transition-colors"
                    title="Sebelumnya"
                >
                    <CaretLeft size={26} weight="bold" />
                </button>
            )}
            {onNext && (
                <button
                    data-testid="lightbox-next"
                    onClick={(e) => {
                        e.stopPropagation();
                        onNext();
                    }}
                    className="absolute right-2 sm:right-4 z-10 text-white/90 hover:text-white bg-white/10 rounded-full p-2.5 transition-colors"
                    title="Berikutnya"
                >
                    <CaretRight size={26} weight="bold" />
                </button>
            )}
            <img
                src={src}
                alt={alt || "Rendering"}
                className="max-w-[92vw] max-h-[86vh] object-contain"
                onClick={(e) => e.stopPropagation()}
                data-testid="lightbox-image"
            />
            {caption && (
                <div className="absolute bottom-4 inset-x-0 flex justify-center px-4 pointer-events-none" data-testid="lightbox-caption">
                    {caption}
                </div>
            )}
        </div>
    );
};
